import type { SectionItem } from '../SidebarSection';
import vehicleStyles from './styles/SystemVehiclesTable.module.scss';

export const SystemVehiclesSidebarContent = ({
    vehicleName,
    isStale,
    sidebarItems,
}: {
    vehicleName: string;
    isStale: boolean;
    sidebarItems: SectionItem[];
}) => (
    <div>
        <div className='margin-left-20'>
            <h4 className='text-bold padding-top-15 padding-bottom-15'>{vehicleName}</h4>
        </div>
        <div className='margin-top-20 padding-left-20 padding-right-20 text-color-darkest'>
            {isStale && (
                <div className={`alert alert-dismissible alert-warning ${vehicleStyles.VehicleSidebarAlert}`}>
                    <div className='display-flex gap-10'>
                        <span className='text-color-warning text-size-h4 rioglyph rioglyph-exclamation-sign' />
                        <div>
                            <strong className='text-size-16 font-weight-600'>Stale vehicle</strong>
                            <div className='margin-y-5 text-size-14'>
                                The vehicle has not been connected for over 30 days, which could indicate that it’s no
                                longer used.
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <ul className='margin-top-20'>
                {sidebarItems.map((item, index) => (
                    <li
                        className={vehicleStyles.VehicleSidebarSectionRow}
                        key={item.label + '-sidebar-section-' + index}
                    >
                        <p className={vehicleStyles.VehicleSidebarSectionRow__label}>{item.label}</p>
                        <span className={vehicleStyles.VehicleSidebarSectionRow__value}>{item.element}</span>
                    </li>
                ))}
            </ul>
        </div>
    </div>
);

export default SystemVehiclesSidebarContent;
